export default __webpack_public_path__ + "static/media/Icons_Water_Fill_Green Icon.c83d5eb8.svg";